import React from 'react';
import JournalDumbView from '../../../DeviationViews/Dumbo/Journal';
import s from './Journal.scss';
const JournalThumbReactView = (props)=>/*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width: props.width,
            height: props.height
        }
    }, /*#__PURE__*/ React.createElement(JournalDumbView, props));
JournalThumbReactView.displayName = 'JournalThumbReactView';
export default JournalThumbReactView;

//# sourceMappingURL=Journal.js.map